import React from "react";

import { TransitionWrapper } from "@trailhead/core-ui";

import { homepageVersionState, useHomepage } from "../states/pathfinder";
import { useSetRecoilState } from "recoil";
import PageBuilder from "@trailhead/page-builder";
import { PartnerType } from "@trailhead/contentful";
import { useMxContext } from "@trailhead/mx-context/src";

export const Homepage = (): JSX.Element => {
    const homepage = useHomepage();
    const { client } = useMxContext();

    const setHomepageVersion = useSetRecoilState(homepageVersionState);

    const homepageVersion = client === PartnerType.VERIZON ? "self-guided--verified" : "loading";
    setHomepageVersion(homepageVersion);

    const mxHeaderOverride = {
        subNavConfig: {
            showBackButton: false,
        }
    };

    return (
        <TransitionWrapper isLoaded={!!homepage} useLoader={true}>
            {!!homepage && <PageBuilder page={homepage} mxHeaderOverride={mxHeaderOverride} />}
        </TransitionWrapper>
    );
}

export default Homepage;
